const TimePeriod = require('./TimePeriod');
const DateChecker = require('./DateChecker');

class EntitlementPeriod extends TimePeriod{
    constructor(constructorObject = {}){
        super(constructorObject.startDate,
            constructorObject.endDate);

        this.entitlementDetails = [];
        this.entitlementsRemaining = {};
    }

    containsBookingDate(bookingDate){
        return this.containsDate(new Date(bookingDate.date))
    }
}

module.exports = EntitlementPeriod;